import { IonButton, IonCol, IonContent, IonGrid, IonHeader ,IonItem, IonRow } from "@ionic/react"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../Hooks"
import { selectUser, setStateUser } from "../../reducers/UserReducer"
import "./GeneralSetting.css"
import { API_URL } from "../../actions/settings"
import NotificationPopUp from "../extras/NotificationPopUp"
import AE2Input from "../elements/AE2Input"
import AIModal from "../elements/AIModal"

async function editUser(data:any,token:string) {
    return fetch(`${API_URL}/user`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization':token
        },
        body: JSON.stringify(data)

      })
        .then(data => data.json())
     }

async function uploadUserImage(file:File,token:string) {
    const body = new FormData()
    body.append('image',file)
    return fetch(`${API_URL}/user/image`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization':token
        },
        body
      })
        .then(data => data.json())
     }

async function deleteUserImage(token:string) {
    return fetch(`${API_URL}/user/image`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization':token
        }
      })
        .then(data => data.json())
     }

const startErrors = {
    first_name:"",
    last_name:"",
    username:"",
    email:"",
}


const GeneralSettings:React.FC = () => {
    const user = useAppSelector(selectUser)
    const dispatch = useAppDispatch()
    const [showNameModal, setShowNameModal] = useState(false)
    const [showUsernameModal, setShowUsernameModal] = useState(false)
    const [showEmailModal, setShowEmailModal] = useState(false)
    const [showWorkGroupModal, setShowWorkGroupModal] = useState(false)
    const [workGroupForm, setWorkGroupForm] = useState({work_group:""})
    const [errors, setErrors] = useState(startErrors)

    const startNameForm = {
        first_name : "",
        last_name : "",
    }
    const startUsernameForm = {
        username : ""
    }
    const startEmailForm = {
        email : ""
    }

    const [nameForm, setNameForm] = useState(startNameForm)
    const [usernameForm, setUsernameForm] = useState(startUsernameForm)
    const [emailForm, setEmailForm] = useState(startEmailForm)

    const getDate = (fullDate:any) =>{
        const date = new Date(fullDate)

        const string = `${date.getMonth()}-${date.getDate()}-${date.getFullYear()}`
        return string
    }

    const handleFormChange = (value:any,name:string,setForm:any) => {
        console.log(value)
        validate(name,value)
        setForm((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )

    }

    useEffect(()=>{
        setNameForm({
            first_name: user.first_name,
            last_name: user.last_name
        })
        setUsernameForm({
            username : user.username
        })
        setEmailForm({
            email: user.email
        })
        setWorkGroupForm({
            work_group: user.work_group ?? ""
        })
    },[user])

    const handleWorkGroupChange = async (e:any) => {
        e.preventDefault()
        const token:any = localStorage.getItem('token')
        const res = await editUser(workGroupForm,`Token ${token.slice(1,-1)}`)
        if (res.status === "success"){
            dispatch(setStateUser(res.user))
            NotificationPopUp('success','Work Group was Edited')
        }
        else{
            NotificationPopUp('error',`Work Group could not be edited. 
 ${res.error}`)
        }
        setShowWorkGroupModal(false)
    }

    const handleImageUpload = async (e:any) => {
        const file:File|undefined = e.target.files?.[0]
        e.target.value = ""
        if(!file) return
        const token:any = localStorage.getItem('token')
        const res = await uploadUserImage(file,`Token ${token.slice(1,-1)}`)
        if (res.status === "success"){
            dispatch(setStateUser(res.user))
            NotificationPopUp('success','Image was Updated')
        }
        else{
            NotificationPopUp('error',`Image could not be updated. 
 ${res.error}`)
        }
    }

    const handleImageRemove = async () => {
        const token:any = localStorage.getItem('token')
        const res = await deleteUserImage(`Token ${token.slice(1,-1)}`)
        if (res.status === "success"){
            dispatch(setStateUser(res.user))
            NotificationPopUp('success','Image was Removed')
        }
        else{
            NotificationPopUp('error','Image could not be removed')
        }
    }


    const handleNameChange = async (e:any) => {
        e.preventDefault()
        if(errors.first_name === "" && errors.last_name === "")
        {
            const token:any = localStorage.getItem('token')
            const res = await editUser(nameForm,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                dispatch(setStateUser(res.user))
                NotificationPopUp('success','Name was Edited')
            }
            else{
                NotificationPopUp('error',`Name could not be edited. \n ${res.error}`)
            }
            setShowNameModal(false)
        }

    }
    const handleUsernameChange = async (e:any) => {
        e.preventDefault()
        if (errors.username === ""){
            const token:any = localStorage.getItem('token')
            const res = await editUser(usernameForm,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                dispatch(setStateUser(res.user))
                NotificationPopUp('success','Username was Edited')
            }
            else{
                NotificationPopUp('error',`Username could not be edited. \n ${res.error}`)
            }
            setShowUsernameModal(false)
        }

    }
    const handleEmailChange = async (e:any) => {
        e.preventDefault()
        if (errors.email === ""){
            const token:any = localStorage.getItem('token')
            const res = await editUser(emailForm,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                dispatch(setStateUser(res.user))
                NotificationPopUp('success','Email was Edited')
            }
            else{
                NotificationPopUp('error',`Email could not be edited. \n ${res.error}`)
            }
            setShowEmailModal(false)
        }

    }

    const validate = (name:string, val:any) =>{
        const regExp = /\s/;
        const emailExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        switch (name) {
            case 'first_name':
                if(val === null || val.length <=1){
                    setErrors({...errors, first_name:"Not a Valid Name"})
                }
                else{
                    setErrors({...errors, first_name:""})
                }

                break;
            case 'last_name':
                if(val === null || val.length <=1){
                    setErrors({...errors, last_name:"Not a Valid Last Name"})
                }
                else{
                    setErrors({...errors, last_name:""})
                }
                break;
            case 'username':
                if(val === null || val.length <=1){
                    setErrors({...errors, username:"Not a Valid username"})
                }
                else if (regExp.test(val)){
                    setErrors({...errors, username:"Cannot Contain Spaces"})
                }
                else{
                    setErrors({...errors, username:""})
                }
                break;
            case 'email':
                if(val === null || val.length <=1){
                    setErrors({...errors, email:"Email To Short"})
                }
                else if (regExp.test(val)){
                    setErrors({...errors, email:"Cannot Contain Spaces"})
                }
                else if (!emailExp.test(val)){
                    setErrors({...errors, email:"Not A Valid Email"})
                }
                else{
                    setErrors({...errors, email:""})
                }
                break;

            }
    }


    return (
        <div>
            <IonHeader className="header"> <h2>General Account Info and Settings</h2></IonHeader>
                <IonGrid fixed>
                    <IonRow className="setting-row">
                        <IonCol size="3">Name:</IonCol>
                        <IonCol size="7">{user.first_name!} {user.last_name!}</IonCol>
                        <IonCol size="2"><IonButton id="nameBtn" size="small" color="dark" onClick={() => setShowNameModal(true)}>Edit</IonButton></IonCol>
                        <AIModal
                            opened={showNameModal}
                            setOpened={setShowNameModal}
                            onDidDismiss={() => setShowNameModal(false)}
                            title="Edit Name">
                                <IonContent>
                                    <form onSubmit={handleNameChange}>
                                        <IonItem>
                                            <AE2Input labelPlacement="floating" label="First Name" style={{color:'black'}} errorText={errors.first_name} value={nameForm.first_name} onIonInput={e => {handleFormChange(e.detail.value!,'first_name',setNameForm)}}/>
                                        </IonItem>
                                        <IonItem>
                                            <AE2Input  style={{color:'black'}} label="Last Name:" labelPlacement="stacked" className={errors.last_name === '' ? "valid":'ion-invalid ion-touched'} errorText={errors.last_name} value={nameForm.last_name} onIonInput={e => {handleFormChange(e.detail.value!,'last_name',setNameForm)}}/>
                                        </IonItem>
                                        <IonRow className="modal-btns">
                                            <IonButton expand="block" type="submit">
                                              Save Changes
                                            </IonButton>
                                        </IonRow>
                                    </form>
                                </IonContent>
                            </AIModal>
                    </IonRow>
                    <IonRow className="setting-row">
                        <IonCol size="3">Username:</IonCol>
                        <IonCol size="7">{user.username!}</IonCol>
                        <IonCol size="2"><IonButton id="emailBtn" size="small" color="dark" onClick={()=> {setShowUsernameModal(true)}}>Edit</IonButton></IonCol>
                        <AIModal
                            opened={showUsernameModal}
                            setOpened={setShowNameModal}
                            onDidDismiss={() => setShowUsernameModal(false)}
                            title="Edit Username">
                                <IonContent>
                                    <form  onSubmit={handleUsernameChange}>
                                        <IonItem>
                                            <AE2Input  style={{color:'black'}} label='Username:' labelPlacement='stacked' className={errors.username === '' ? "valid":'ion-invalid ion-touched'} errorText={errors.username} value={usernameForm.username} onIonChange={e => {handleFormChange(e.detail.value!,'username',setUsernameForm)}}/>
                                        </IonItem>
                                        <IonRow className="modal-btns">
                                            <IonButton expand="block" type="submit">
                                              Save Changes
                                            </IonButton>
                                        </IonRow>
                                    </form>
                                </IonContent>
                            </AIModal>
                    </IonRow>
                    <IonRow className="setting-row">
                        <IonCol size="3">Email:</IonCol>
                        <IonCol size="7">{user.email!}</IonCol>
                        <IonCol size="2"><IonButton id="usernameBtn" size="small" color="dark" onClick={() => {setShowEmailModal(true)}}>Edit</IonButton></IonCol>
                        <AIModal
                            opened={showEmailModal}
                            setOpened={setShowEmailModal}
                            onDidDismiss={() => setShowEmailModal(false)}
                            title='Edit Email'>
                                <IonContent>
                                    <form onSubmit={handleEmailChange}>
                                        <IonItem>
                                            <AE2Input  style={{color:'black'}} label="Email:" labelPlacement="stacked" className={errors.email === '' ? "valid":'ion-invalid ion-touched'} errorText={errors.email} value={emailForm.email} onIonChange={e => {handleFormChange(e.detail.value!,'email',setEmailForm)}}/>
                                        </IonItem>
                                        <IonRow className="modal-btns">
                                            <IonButton expand="block"  type="submit">
                                              Save Changes
                                            </IonButton>
                                        </IonRow>
                                    </form>
                                </IonContent>
                            </AIModal>
                    </IonRow>
                    <IonRow className="setting-row">
                        <IonCol size="3">Work Group:</IonCol>
                        <IonCol size="7">{user.work_group}</IonCol>
                        <IonCol size="2"><IonButton id="workGroupBtn" size="small" color="dark" onClick={() => setShowWorkGroupModal(true)}>Edit</IonButton></IonCol>
                        <AIModal
                            opened={showWorkGroupModal}
                            setOpened={setShowWorkGroupModal}
                            onDidDismiss={() => setShowWorkGroupModal(false)}
                            title="Edit Work Group"
                            >
                                <IonContent>
                                    <form style={{width:'100%'}} onSubmit={handleWorkGroupChange}>
                                        <IonItem>
                                            <AE2Input style={{color:'black'}} label="Work Group:" labelPlacement="stacked" value={workGroupForm.work_group} onIonInput={e => {handleFormChange(e.detail.value!,'work_group',setWorkGroupForm)}}/>
                                        </IonItem>
                                        <IonRow className="modal-btns">
                                            <IonButton expand="block" type="submit">
                                              Save Changes
                                            </IonButton>
                                        </IonRow>
                                    </form>
                                </IonContent>
                            </AIModal>
                    </IonRow>
                    <IonRow className="setting-row">
                        <IonCol size="3">Image:</IonCol>
                        <IonCol size="7">{user.image_url ? <img alt="profile" src={user.image_url} style={{width:'64px',height:'64px',borderRadius:'50%',objectFit:'cover'}}/> : "No image"}</IonCol>
                        <IonCol size="2">
                            <input id="userImageInput" type="file" accept="image/*" style={{display:'none'}} onChange={handleImageUpload}/>
                            <IonButton size="small" color="dark" onClick={() => document.getElementById('userImageInput')?.click()}>Upload</IonButton>
                            {user.image_url ? <IonButton size="small" color="danger" onClick={handleImageRemove}>Remove</IonButton> : null}
                        </IonCol>
                    </IonRow>
                    <IonRow className="setting-row">
                        <IonCol size="3">Joined Date:</IonCol>
                        <IonCol size="7">{getDate(user.date_joined)}</IonCol>
                    </IonRow>
                </IonGrid>


        </div>
    )
}

export default GeneralSettings